import { render, staticRenderFns } from "./DetailedAccounts.vue?vue&type=template&id=68a6c612&scoped=true"
import script from "./DetailedAccounts.vue?vue&type=script&lang=js"
export * from "./DetailedAccounts.vue?vue&type=script&lang=js"
import style0 from "./DetailedAccounts.vue?vue&type=style&index=0&id=68a6c612&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a6c612",
  null
  
)

export default component.exports